import { INFORMATION_NOT_AVAILABLE } from '../../../utils/constants';
import { capitalizeString } from '../../../utils/globalHelpers';
import { REASON_CODE_DICTIONARY } from './constants';
import { initialState } from './reducer';

export const determineValuesToValidate = (
  isAddressCanadian,
  isAddressInternational,
  internationalRequestBody,
  requestBody,
) => {
  if (isAddressCanadian) {
    return internationalRequestBody;
  }
  if (isAddressInternational) {
    const { province, ...restBody } = internationalRequestBody;
    return restBody;
  }
  return requestBody;
};

export const formatDomesticMailingAddress = (addressData) => {
  const {
    addressCity: city,
    addressLine3: companyOrCareOf,
    addressLine4: apartment,
    addressLine5: streetAddress,
    addressPostalCode: zipCode,
    addressState: state,
  } = addressData;

  return {
    apartment: apartment || '',
    cityStateZip: city
      ? `${capitalizeString(city)}, ${state} ${zipCode}`
      : '',
    companyOrCareOf: companyOrCareOf || '',
    streetAddress: `${capitalizeString(streetAddress)}` || INFORMATION_NOT_AVAILABLE,
  };
};

export const formatInternationalMailingAddress = (addressData, countries) => {
  const {
    addressCity: city,
    addressCountry,
    addressLine3: additionalLine2,
    addressLine4: additionalLine3,
    addressLine5: streetAddress,
    addressPostalCode: postalCode,
    addressState: province,
  } = addressData;
  const fullCountryName =
    countries.reduce((acc, country) => country.value === addressCountry ? country.label : acc, '');

  return {
    addressLine2: additionalLine2 || '',
    addressLine3: additionalLine3 || '',
    cityProvincePostalCode: city
      ? `${capitalizeString(city)}${province ? ',' : ''} ${province || ''} ${postalCode || ''}`
      : '',
    country: fullCountryName,
    streetAddress: `${capitalizeString(streetAddress)}` || INFORMATION_NOT_AVAILABLE,
  };
};

export const formatReadOnlyFields = (readOnlyFields) => {
  const dict = {
    Address_City: 'city',
    Address_Line_2: 'addressLine2',
    Address_Line_3: 'company',
    Address_Line_4: 'apartment',
    Address_Line_5: 'streetAddress',
    Address_Postal_Code: 'zip',
    Address_State: 'state',
  };
  if (!readOnlyFields) {
    return [];
  }
  return readOnlyFields.map((field) => dict[field]);
};

export const getChangeValidationFailurePayload = (form, reasons) => {
  const { forms } = initialState;
  const updatedState = reasons.reduce((acc, reason) => {
    const { field, message } = REASON_CODE_DICTIONARY[reason] || {};
    if (forms[form][field] !== undefined) {
      if (acc[field] !== undefined) {
        acc[field] = message || 'Invalid input.';
      }
    }
    return acc;
  }, { ...forms[form] });
  const noChanges =
    Object.keys(updatedState).every(
      (key) => updatedState[key] === forms[form][key],
    );
  return !noChanges && updatedState;
};
